import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { Modal, Button } from '@bingads-webui-react/primitive';
import { TaxDialogStyles } from '../styles/tax-dialog';

const UnthemedConfirmNoGSTINDialog = ({
  onUpdateClick,
  onDismissClick,
  show,
  i18n,
  classes,
}) => (
  <Modal show={show} backdrop="static" className="confirm-no-gstin-lightbox">
    <Modal.Header className={classes.modalHeader}>
      <Modal.Title>{i18n.getString(_TL_('No GSTIN on file'))}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className={`confirm-no-gstin-lightbox-content ${classes.modalContent}`}>
        {i18n.getString(_TL_('If you need tax invoices for your account, please go back and enter your Goods and Services Tax Identification Number (GSTIN). Without a GSTIN, we can’t provide tax invoices for you.'))}
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button className="confirm-no-gstin-lightbox-update-btn btn-primary" onClick={onUpdateClick}>{i18n.getString(_TL_('Update now'))}</Button>
      <Button className="confirm-no-gstin-lightbox-dismiss-btn" onClick={onDismissClick}>{i18n.getString(_TL_('Dismiss'))}</Button>
    </Modal.Footer>
  </Modal>
);

export const ConfirmNoGSTINDialog = injectSheet(TaxDialogStyles.CommonTaxDialog)(UnthemedConfirmNoGSTINDialog);

UnthemedConfirmNoGSTINDialog.propTypes = {
  onUpdateClick: PropTypes.func.isRequired,
  onDismissClick: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({}).isRequired,
};
